var map = {
	"./colle capital.png": "2e94",
	"./mevp.png": "59f3",
	"./mevp11.png": "f8a0",
	"./shlonik.png": "ae05",
	"./streamingLogo.png": "0d98",
	"./tamam.png": "1e77",
	"./wamda.png": "c81e",
	"./wasfa.png": "9042",
	"./zain-cash.png": "6b1a",
	"./zain-logo-black3.png": "34aa",
	"./zain-logo-black4.png": "ac36",
	"./zainLogo.png": "5de6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf0c";